import { graphql } from 'relay-runtime';

export const createTimeSession = graphql`
  mutation TimeOnPlatformCreateMutation {
    createUserPlatformSession {
      userPlatformSessionNode {
        id
      }
    }
  }
`;
export const updateTimeSession = graphql`
  mutation TimeOnPlatformUpdateMutation($input: UpdateUserPlatformSessionLastPingInput!) {
    updateUserPlatformSessionLastPing(input: $input) {
      userPlatformSessionNode {
        id
      }
    }
  }
`;
